import React, { useEffect, useState } from "react";
import logo from "../../../assets/images/logosalerno.png";
import eu_logo from "../../../assets/icons/it_finanziato_eu.svg";
import icons from "bootstrap-italia/dist/svg/sprites.svg";
import { LAYOUT_URL } from "../../../server";

const Footer = () => {
  const [footerMenus, setFooterMenus] = useState(null);

  useEffect(() => {
    fetch(`${LAYOUT_URL}footer-menus`)
      .then((res) => res.json())
      .then(setFooterMenus)
      .catch((err) => {
        console.error("Errore caricando footer-menus", err);
      });
  }, []);
  const customFooter = footerMenus?.customfooter;
  const contattiMenu = footerMenus?.["footer---contatti"];
  const baseFooter = footerMenus?.footer;
  const social = footerMenus?.social;

  const sortByWeight = (a, b) =>
    Number(a?.weight ?? 0) - Number(b?.weight ?? 0);

  const getSectionByTitle = (title) =>
    customFooter?.items?.find((item) => item.title === title);

  const amministrazione = getSectionByTitle("Amministrazione");
  const categorie = getSectionByTitle("Categorie di servizio");
  const novita = getSectionByTitle("Novità");
  const vivereComune = getSectionByTitle("Vivere il comune");

  const categorieChildren = categorie?.children
    ? [...categorie.children].sort(sortByWeight)
    : [];
  const categorieMid = Math.ceil(categorieChildren.length / 2);
  const categorieCol1 = categorieChildren.slice(0, categorieMid);
  const categorieCol2 = categorieChildren.slice(categorieMid);

  const contattiItems = contattiMenu?.items
    ? [...contattiMenu.items].sort(sortByWeight)
    : [];

  const contattiMid = Math.ceil(contattiItems.length / 2);
  const contattiCol1 = contattiItems.slice(0, contattiMid - 1);
  const contattiCol2 = contattiItems.slice(contattiMid - 1);

  const renderLink = (item) => {
    if (!item) return null;
    const href = item.url && item.url !== "" ? item.url : "#";
    const isExternal = item.external;

    // opzionale: data-element per alcuni titoli noti
    const extraProps = {};
    if (item.title === "Leggi le FAQ") {
      extraProps["data-element"] = "faq";
    } else if (item.title === "Segnalazione disservizio") {
      extraProps["data-element"] = "report-inefficiency";
    } else if (item.title === "Note legali") {
      extraProps["data-element"] = "legal-notes";
    } else if (item.title === "Informativa privacy") {
      extraProps["data-element"] = "privacy-policy-link";
    } else if (item.title === "Dichiarazione di accessibilità") {
      extraProps["data-element"] = "accessibility-link";
    }

    return (
      <a
        href={href}
        target={isExternal ? "_blank" : undefined}
        rel={isExternal ? "noreferrer" : undefined}
        {...extraProps}
      >
        {item.title}
      </a>
    );
  };

  const getSocialIconId = (url) => {
    if (!url) return "it-link";
    const lower = url.toLowerCase();
    if (lower.includes("facebook")) return "it-facebook";
    if (lower.includes("youtube")) return "it-youtube";
    return "it-link";
  };

  console.log("Footer menus:", footerMenus);

  return (
    <>
      <footer className="it-footer" id="footer">
        <div className="it-footer-main">
          <div className="container">
            {/* LOGHI */}
            <div className="row">
              <div className="col-12 footer-items-wrapper logo-wrapper">
                <div className="ue-logo">
                  <span className="visually-hidden">logo Unione Europea</span>
                </div>
                <div className="it-brand-wrapper">
                  <div className="row">
                    <div className="col-md-2 col-12" style={{ width: "200px" }}>
                      <a href={`/`}>
                        <img
                          className="mr-4"
                          aria-hidden="true"
                          src={eu_logo}
                          alt="eu_logo"
                        />
                        <div className="it-brand-text"></div>
                      </a>
                    </div>
                    <div className="col">
                      <a href={`/`}>
                        <img
                          className="mr-4"
                          style={{ width: "95px" }}
                          aria-hidden="true"
                          src={logo}
                          alt="logo"
                        />
                        <div className="it-brand-text">
                          <h2 className="no_toc">Comune di Salerno</h2>
                        </div>
                      </a>
                    </div>
                  </div>
                </div>
                <div className="gstc-logo">
                  <span className="visually-hidden">logo GSTC</span>
                </div>
                <div className="vireo-logo">
                  <span className="visually-hidden">logo Vireo</span>
                </div>
              </div>
            </div>

            {/* NAVIGAZIONE PRINCIPALE FOOTER */}
            <div className="row">
              {/* AMMINISTRAZIONE */}
              <div className="col-md-3 footer-items-wrapper">
                <h3 className="footer-heading-title">
                  {amministrazione?.title || "Amministrazione"}
                </h3>
                <div className="menu-amministrazione-container">
                  {amministrazione?.children?.length ? (
                    <ul id="menu-amministrazione" className="footer-list">
                      {amministrazione.children
                        .sort(sortByWeight)
                        .map((item) => (
                          <li key={`${item.title}-${item.url || "local"}`}>
                            {renderLink(item)}
                          </li>
                        ))}
                    </ul>
                  ) : (
                    // Fallback hardcodato
                    <ul id="menu-amministrazione" className="footer-list">
                      <li>
                        <a href={`/amministrazione/organi-di-governo/`}>
                          Organi di governo
                        </a>
                      </li>
                      <li>
                        <a href={`/amministrazione/aree-amministrative/`}>
                          Aree amministrative
                        </a>
                      </li>
                      <li>
                        <a href={`/amministrazione/uffici/`}>Uffici</a>
                      </li>
                      <li>
                        <a href={`/amministrazione/enti-e-fondazioni/`}>
                          Enti e fondazioni
                        </a>
                      </li>
                      <li>
                        <a href={`/amministrazione/politici/`}>Politici</a>
                      </li>
                      <li>
                        <a href={`/amministrazione/personale-amministrativo/`}>
                          Personale amministrativo
                        </a>
                      </li>
                      <li>
                        <a href={`/amministrazione/documenti-e-dati/`}>
                          Documenti e Dati
                        </a>
                      </li>
                    </ul>
                  )}
                </div>
              </div>

              {/* CATEGORIE DI SERVIZIO */}
              <div className="col-md-6 footer-items-wrapper">
                <h3 className="footer-heading-title">
                  {categorie?.title || "Categorie di servizio"}
                </h3>
                <div className="row">
                  <div className="col-md-6">
                    <ul className="footer-list">
                      {categorieCol1.length ? (
                        categorieCol1.map((item) => (
                          <li key={`${item.title}-${item.url || "local"}`}>
                            {renderLink(item)}
                          </li>
                        ))
                      ) : (
                        <>
                          <li>
                            <a href="/categorie-dei-servizi/anagrafe-e-stato-civile">
                              Anagrafe e stato civile
                            </a>
                          </li>
                          <li>
                            <a href="/categorie-dei-servizi/cultura-e-tempo-libero">
                              Cultura e tempo libero
                            </a>
                          </li>
                          <li>
                            <a href="/categorie-dei-servizi/vita-lavorativa">
                              Vita lavorativa
                            </a>
                          </li>
                          <li>
                            <a href="/categorie-dei-servizi/imprese-e-commercio">
                              Imprese e commercio
                            </a>
                          </li>
                          <li>
                            <a href="/categorie-dei-servizi/appalti-pubblici">
                              Appalti pubblici
                            </a>
                          </li>
                          <li>
                            <a href="/categorie-dei-servizi/turismo">Turismo</a>
                          </li>
                          <li>
                            <a href="/categorie-dei-servizi/mobilita-e-trasporti">
                              Mobilità e trasporti
                            </a>
                          </li>
                          <li>
                            <a href="/categorie-dei-servizi/educazione-e-formazione">
                              Educazione e formazione
                            </a>
                          </li>
                        </>
                      )}
                    </ul>
                  </div>
                  <div className="col-md-6">
                    <ul className="footer-list">
                      {categorieCol2.length ? (
                        categorieCol2.map((item) => (
                          <li key={`${item.title}-${item.url || "local"}`}>
                            {renderLink(item)}
                          </li>
                        ))
                      ) : (
                        <>
                          <li>
                            <a href="/categorie-dei-servizi/giustizia-e-sicurezza-pubblica">
                              Giustizia e sicurezza pubblica
                            </a>
                          </li>
                          <li>
                            <a href="/categorie-dei-servizi/tributi-finanze-e-contravvenzioni">
                              Tributi, finanze e contravvenzioni
                            </a>
                          </li>
                          <li>
                            <a href="/categorie-dei-servizi/ambiente">
                              Ambiente
                            </a>
                          </li>
                          <li>
                            <a href="/categorie-dei-servizi/salute-benessere-e-assistenza">
                              Salute, benessere e assistenza
                            </a>
                          </li>
                          <li>
                            <a href="/categorie-dei-servizi/autorizzazioni">
                              Autorizzazioni
                            </a>
                          </li>
                          <li>
                            <a href="/categorie-dei-servizi/agricoltura-e-pesca">
                              Agricoltura e pesca
                            </a>
                          </li>
                          <li>
                            <a href="/categorie-dei-servizi/diritti-e-partecipazione">
                              Diritti e partecipazione
                            </a>
                          </li>
                        </>
                      )}
                    </ul>
                  </div>
                </div>
              </div>

              {/* NOVITÀ + VIVERE IL COMUNE */}
              <div className="col-md-3 footer-items-wrapper">
                <h3 className="footer-heading-title">
                  {novita?.title || "Novità"}
                </h3>
                <div className="footer-list">
                  <ul id="menu-novita" className="footer-list">
                    {novita?.children?.length ? (
                      novita.children
                        .sort(sortByWeight)
                        .map((item) => (
                          <li key={`${item.title}-${item.url || "local"}`}>
                            {renderLink(item)}
                          </li>
                        ))
                    ) : (
                      <>
                        <li>
                          <a href={`/novita`}>Notizie</a>
                        </li>
                        <li>
                          <a href={`/novita`}>Comunicati</a>
                        </li>
                        <li>
                          <a href={`/novita`}>Avvisi</a>
                        </li>
                      </>
                    )}
                  </ul>
                </div>

                <h3
                  className="footer-heading-title"
                  style={{ marginTop: "2.667rem" }}
                >
                  {vivereComune?.title || "Vivere il Comune"}
                </h3>
                <div className="menu-vivere-il-comune-container">
                  <ul id="menu-vivere-il-comune" className="footer-list">
                    {vivereComune?.children?.length ? (
                      vivereComune.children
                        .sort(sortByWeight)
                        .map((item) => (
                          <li key={`${item.title}-${item.url || "local"}`}>
                            {renderLink(item)}
                          </li>
                        ))
                    ) : (
                      <>
                        <li>
                          <a href={`/vivere-il-comune`}>Luoghi</a>
                        </li>
                        <li>
                          <a href={`/vivere-il-comune`}>Eventi</a>
                        </li>
                      </>
                    )}
                  </ul>
                </div>
              </div>

              {/* CONTATTI */}
              <div className="col-md-9 mt-md-4 footer-items-wrapper">
                <h3 className="footer-heading-title">Contatti</h3>
                <div className="row">
                  {/* BLOCCO HARD-CODATO INDIRIZZO */}
                  <div className="col-md-4">
                    <p className="footer-info">
                      <span className="font-bold">Comune di Salerno</span>
                      <br />
                      Via Roma - Palazzo di Città, 84100 Salerno
                      <br />
                      C.F 80000330656 P.IVA 00263650657
                      <br />
                    </p>
                  </div>

                  {/* LINK DA footer---contatti */}
                  <div className="col-md-4">
                    <div className="menu-info-1-container">
                      <ul id="menu-info-1" className="footer-list">
                        {contattiCol1.length ? (
                          contattiCol1.map((item) => (
                            <li key={`${item.title}-${item.url || "local"}`}>
                              {renderLink(item)}
                            </li>
                          ))
                        ) : (
                          // fallback della tua versione attuale
                          <>
                            <li>
                              <a
                                href={`/domande-frequenti/`}
                                data-element="faq"
                              >
                                Leggi le FAQ
                              </a>
                            </li>
                            <li>
                              <a href={`/prenotazione-appuntamento/`}>
                                Prenotazione appuntamento
                              </a>
                            </li>
                            <li>
                              <a
                                href={`/segnalazioni_page/`}
                                data-element="report-inefficiency"
                              >
                                Segnalazione disservizio
                              </a>
                            </li>
                            <li>
                              <a href={`/servizi/assistenza/`}>
                                Richiesta assistenza
                              </a>
                            </li>
                          </>
                        )}
                      </ul>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="menu-info-2-container">
                      <ul id="menu-info-2" className="footer-list">
                        {contattiCol2.length ? (
                          contattiCol2.map((item) => (
                            <li key={`${item.title}-${item.url || "local"}`}>
                              {renderLink(item)}
                            </li>
                          ))
                        ) : (
                          <>
                            <li>
                              <a href={`/amministrazione-trasparente`}>
                                Amministrazione trasparente
                              </a>
                            </li>
                            <li>
                              <a
                                href={`/note-legali`}
                                data-element="legal-notes"
                              >
                                Note legali
                              </a>
                            </li>
                            <li>
                              <a href={``} data-element="accessibility-link">
                                Dichiarazione di accessibilità
                              </a>
                            </li>
                            <li>
                              <a href={`/prenotazione-appuntamento/servizio`}>
                                Albo pretorio
                              </a>
                            </li>
                            <li>
                              <a
                                href={`/privacy/`}
                                data-element="privacy-policy-link"
                              >
                                Informativa privacy
                              </a>
                            </li>
                          </>
                        )}
                      </ul>
                    </div>
                  </div>
                </div>
              </div>

              {/* SOCIAL */}
              <div className="col-md-3 mt-md-4 footer-items-wrapper ">
                <h3 className="footer-heading-title">
                  {social?.label || "Seguici su"}
                </h3>

                <ul className="list-inline text-start social">
                  {(social?.items && social.items.length
                    ? social.items
                    : [
                        {
                          url: "https://it-it.facebook.com/ComuneSalerno",
                          title: "Facebook",
                        },
                        {
                          url: "https://www.youtube.com/user/CittadiSalerno",
                          title: "YouTube",
                        },
                      ]
                  ).map((item, idx) => (
                    <li className="list-inline-item" key={`${item.url}-${idx}`}>
                      <a
                        href={item.url}
                        aria-label={item.title || "Social"}
                        target="_blank"
                        rel="noreferrer"
                      >
                        <svg className="icon icon-white">
                          <use
                            href={`${icons}#${getSocialIconId(item.url)}`}
                          ></use>
                        </svg>
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            </div>

            {/* RIGA FINALE FOOTER (es. Non accessibile) */}
            {/* {baseFooter?.items?.length ? (
              <div className="row mt-3">
                <div className="col-12 footer-items-wrapper">
                  <ul className="footer-list">
                    {baseFooter.items.map((item, idx) => (
                      <li key={`${item.title}-${idx}`}>
                        {item.url ? (
                          <a href={item.url}>{item.title}</a>
                        ) : (
                          <span>{item.title}</span>
                        )}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            ) : null} */}
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;
